module.exports = __webpack_public_path__ + "img/nycpg-logo-white.9aae7e0d.svg";